import { useCallback } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { getIn } from 'formik';

import { FCheckbox } from '../../../../../../components/baseV2';
import { ADDITIONAL_FILES_VIEWED_OPTIONS } from '../constants';
import { ADDITIONAL_FILES_FIELDSET_SX, ADDITIONAL_FILES_LEGEND_SX } from '../styles';

import type { AdditionalFilesViewedFieldProps } from './types';

export default function AdditionalFilesViewedField({
  formik,
  disabled,
  readOnly,
  saveField,
}: AdditionalFilesViewedFieldProps) {
  const selected = [getIn(formik.values, 'additional_files_viewed')].flatMap((value) =>
    Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [],
  );
  const handleToggle = useCallback(
    (option: string, checked: boolean) => {
      const next = checked
        ? [...selected, option]
        : selected.filter((value) => value !== option);
      formik.setFieldValue('additional_files_viewed', next);
      saveField('additional_files_viewed', next);
    },
    [formik, saveField, selected],
  );

  return (
    <Box sx={ADDITIONAL_FILES_FIELDSET_SX}>
      <Typography component="span" sx={ADDITIONAL_FILES_LEGEND_SX}>
        Additional files viewed
      </Typography>
      <Grid container spacing={2}>
        {ADDITIONAL_FILES_VIEWED_OPTIONS.map((option) => (
          <Grid item key={option} xs={12} md={6}>
            <FCheckbox
              checked={selected.includes(option)}
              disabled={disabled || readOnly}
              label={option}
              onChange={(_event, checked) => handleToggle(option, checked)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
